module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/edit-suggestion/edit-suggestion.component.scss
// module id = ./src/app/edit-suggestion/edit-suggestion.component.scss
// module chunks = main